export const COPAY_ALL_CLAIMS_TABLE = [
  {
    value: 'case_id',
    label: 'Case ID',
  },
  {
    value: 'submitted_date',
    label: 'Submitted',
  },
  {
    value: 'patient_name',
    label: 'Patient',
  },
  {
    value: '',
    label: 'Product',
  },
  {
    value: 'submitting_practice',
    label: 'Submitting Practice',
  },
  {
    value:'',
    label:'Status'
  },
  {
    value:'',
    label:'Copay'
  },
  
  {
    value:'',
    label:'Next Steps'
  },
  {
    value:'days_left',
    label:'Days Left '
  },
];
